module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedThin.73837b7.eot";